import { Skeleton } from '@material-ui/lab';
import { MediaType } from '@model/frontendmodel';
import { useState, VideoHTMLAttributes } from 'react';
import './media-resource_style.css';

export type MediaResourceProps = {
  source: string;
  mediaType: keyof typeof MediaType;
  fallback: React.ReactNode;
};

export type VideoThumbnailProps = {
  source: string;
  onError?(): void;
  onLoad?(): void;
} & VideoHTMLAttributes<HTMLVideoElement>;

export const VideoThumbnail: React.FC<VideoThumbnailProps> = ({
  source,
  onError,
  onLoad,
  // eslint-disable-next-line arrow-body-style
}) => {
  return (
    <video
      style={{
        pointerEvents: 'none',
      }}
      src={source}
      preload="metadata"
      // eslint-disable-next-line react/jsx-boolean-value
      muted={true}
      // eslint-disable-next-line react/jsx-boolean-value
      playsInline={true}
      autoPlay={false}
      controls={false}
      onError={onError}
      onLoadedData={onLoad}
    />
  );
};

const MediaResource: React.FC<MediaResourceProps> = ({
  source,
  mediaType,
  fallback,
}) => {
  const [status, setStatus] = useState<'pending' | 'loaded' | 'error'>(
    'pending'
  );

  const onLoad = () => {
    setStatus('loaded');
  };

  const onError = () => {
    setStatus('error');
  };

  return (
    <div className="media-resource" data-status={status}>
      {/* eslint-disable-next-line no-nested-ternary */}
      {status === 'pending' ? (
        <Skeleton animation="wave" variant="rect" width={140} height={210} />
      ) : status === 'error' ? (
        <>{fallback}</>
      ) : null}
      <div className="media-item">
        {/* eslint-disable-next-line no-nested-ternary */}
        {mediaType === MediaType.IMAGE ? (
          // eslint-disable-next-line jsx-a11y/alt-text
          <img src={source} onLoad={onLoad} onError={onError} />
        ) : mediaType === MediaType.VIDEO ? (
          <VideoThumbnail source={source} onLoad={onLoad} onError={onError} />
        ) : null}
      </div>
    </div>
  );
};

export default MediaResource;
